<div class="container">
  <app-logo />
  <div class="error-container" *ngIf="hasError">
    <p class="error-message">{{ "common.messages.errorLoadingLocations" | translate }}</p>
    <div class="actions">
      <button class="retry-button" (click)="retry()">{{ "common.actions.refresh" | translate }}</button>
      <a (click)="onLogout()" class="logout-link">{{ "auth.notAuthorized.disconnect" | translate }}</a>
    </div>
  </div>
</div>
